import React from 'react'
import { useModal } from '../../hooks/modal'
import { useDeleteRequest } from '../../hooks/request'
import { PAYMENT_DETAIL } from '../../urls'
import PaymentUpdate from './PaymentUpdate'
import Button from '../../components/common/Button'
import { format } from '../../utils/number'

export default function PaymentItem({ item, index, payment }) {
    const productRemove = useDeleteRequest({ url: PAYMENT_DETAIL.replace('{id}', item.id) })

    async function onDelete() {
        if (global.confirm('Вы действительно хотите удалить?')) {
            await productRemove.request()
            payment.request()
        }
    }

    const [showUpdateModal, hideUpdateModal] = useModal(
        <PaymentUpdate
            clients={payment}
            item={item}
            onCancel={() => {
                payment.request()
                hideUpdateModal()
            }}
        />,
    )

    return (
        <tr className=" is-size-6" key={item.id}>
            <td className="is-size-6">{index + 1}</td>
            <td className="is-size-6">{item.selectContract.selectCustomer?.fullName}</td>
            <td className="is-size-6">{(item.paymentDate)}</td>
            <td className="is-size-6">{format(item.amountPaid)}</td>
            <td className="is-size-6">{(item.remainingAmount)}</td>
            <td>
                <div style={{ display: 'flex' }} className="has-text-right">
                    <Button onClick={showUpdateModal} className="mr-2 button is-success is-outlined is-small"
                        icon="pencil-outline" />
                    <Button onClick={onDelete} className="button is-danger mr-2 is-outlined is-small" icon="trash" />
                </div>
            </td>
        </tr>
    )
}
